module.exports = __webpack_public_path__ + "img/antes_despues_164.def32e7e.png";